




























import Vue from 'vue';
import moment from 'moment';
import AppDock from './common/components/AppDock.vue';
import TaskEntry from './common/components/TaskEntry.vue';
import ChatPlugin from './common/components/ChatPlugin.vue';
import Contact from './common/components/Contact.vue';
import EbookBox from './common/components/EbookBox.vue';
import { getCookie, post} from '@/common/utils/Http';
// import DaoVoice from './common/utils/DaoVoice';
import appVuex from './vuex/common';
import appClient from './apis';
import accountClient from './account/apis';
import { FansLevel } from './upgrade/models/Fee';

const screenY = 0;

export default Vue.extend({
  mixins: [appVuex],
  components: {
    AppDock,
    TaskEntry,
    ChatPlugin,
    Contact,
    EbookBox,
  },
  data() {
    return {
      screenY,
      FansLevel,
      inited: false,
      showNavs: true,
      showTaskEntry: true,
      notRedirectPages: ['/user/register', '/user/reset', '/user/resetSuccess', '/account/manage', '/upgrade/buy', '/user/upgrade', '/user/auth'],
      notLoginedPages: ['/user/register', '/user/reset', '/user/resetSuccess', '/user/login'],
    };
  },
  computed: {
    pageClass(): string {
      return 'page' + this.$route.path.split('/').join('-');
    },
  },
  methods: {
    resize() {
      this.screenY = window.innerHeight;
    },
    init() {
      if (this.isLogined()) {
        appClient.loginCheck({}).success((r) => {
          window.localStorage.setItem('account', JSON.stringify(r));
          this.$store.commit('UPDATE_ACCOUNT', r);
          if (!r.isVerified) {  // 判断账号是否认证
            if (this.$route.path !== '/account/manage') {
              window.location.href = '#/user/limit';
            }
          } else {
            if (this.accountState.account.isBlocked) {
              window.location.href = '#/user/illegal';
            }
            this.upgradeCheck();
          }
        });
      } else {
        this.$store.commit('LOGIN_OUT');
        if (!this.notLoginedPages.includes(this.$route.path)) {
          window.location.href = '#/user/login';
        }
      }
      this.inited = true;
    },
    isLogined() {
      const isLogin = getCookie('DRIP_SESSION_KEY_USER_IDENTITY');
      if (this.notLoginedPages.includes(this.$route.path) && isLogin) {
        window.location.href = '#/customer/search';
      }
      return isLogin;
    },
    upgradeCheck() {
      appClient.upgradeCheck({}).success((r) => {
        if (r && !this.notRedirectPages.includes(this.$route.path)) {
          this.showNavs = false;
          this.showTaskEntry = false;
          window.location.href = '#/user/upgrade';
        }
      });
    },
    getTrial() {
      appClient.getTime({}).success((r) => {
        const now = moment(moment(r).format('YYYY-MM-DD'));
        const gmtCreate = moment(moment(this.accountState.account.gmtCreate).format('YYYY-MM-DD'));
        const days = moment.duration(now.diff(gmtCreate)).asDays();
        let isTrial = false;
        if (days <= 3) {
          isTrial = true;
        }
        this.$store.commit('UPDATE_IS_TRIAL', isTrial);
      });
    },
    getCrmLevel() {
      appClient.getCrmLevel({}).success((r) => {
        this.$store.commit('UPDATE_CRM_LEVEL', r.crmLevel);
        this.$store.commit('UPDATE_IS_EXPIRED', r.isExpired);
        window.localStorage.setItem('crmLevel', JSON.stringify(r.crmLevel));
        // DaoVoice.init();
      }).error((e) => {
        this.$Message.error('系统初始错误，请刷新重试');
      });
    },
    getFansLevel() {
      accountClient.getUserTotal({}).success((r) => {
        const userTotal = r;
        if (userTotal <= 100000) {
          this.$store.commit('UPDATE_FANS_LEVEL', FansLevel.Level1);
        } else if (userTotal > 100000 && userTotal <= 1000000) {
          this.$store.commit('UPDATE_FANS_LEVEL', FansLevel.Level2);
        } else if (userTotal > 1000000 && userTotal <= 3000000) {
          this.$store.commit('UPDATE_FANS_LEVEL', FansLevel.Level3);
        } else {
          this.$store.commit('UPDATE_FANS_LEVEL', FansLevel.Level4);
        }
      });
    },
    fixIERouter() {
      function checkIE() {
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
      }
      if (checkIE()) {
        window.addEventListener('hashchange', () => {
          const currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        }, false);
      }
    },
  },
  watch: {
    '$route'(to, from) {
      this.init();
    },
    'accountState.changeAccountNum'() {
      this.getTrial();
      this.getCrmLevel();
      this.getFansLevel();
    },
  },
  mounted() {
    this.resize();
    window.onresize = () => {
      this.resize();
    };
    this.init();
    this.getCrmLevel();
    this.fixIERouter();
  },
});
